import Filter from './filter';
import valueIn from '../../utils/valueIn';

export default Filter((FILTER_TYPES) => ({
    id: 'PRICE',
    analyticsName: 'Price',
    queryKey: 'f_price',
    type: FILTER_TYPES.PRICE,
    bucketify: (hotel, memory) => {
        const mucd = typeof window !== 'undefined' ? valueIn(window, 'ow.independentFlow.appModel.siteId') || 1 : 1;
        const upperLimit = mucd === +15 && 10000 || 100000;

        const price = Math.min(valueIn(hotel, ['priceInfo', 'filterTotalPrice']), upperLimit);

        // NB: This only works because Math.min yields NaN on (undefined, VALID_NUMBER)
        if (!price) {
            return undefined;
        }

        if (memory) {
            memory.maximumPrice = memory.maximumPrice || 0;
            memory.maximumPrice = price > memory.maximumPrice ? price : memory.maximumPrice;
        }

        return {
            bucketId: 'hasPrice',
            bucketName: 'price'
        };
    },
    decorateFinalState: (finalState, filterTree, memory) => {
        finalState.values = finalState.values || {};
        finalState.values.maximumPrice = memory.maximumPrice;
    },
    toQuery: ({ value } = {}, filterStateValues) => {
        const maximumPrice = valueIn(filterStateValues, 'maximumPrice');
        return value && value < maximumPrice ? value : undefined;
    },
    fromQuery: (rawQueryValue) => {
        if (!rawQueryValue || typeof rawQueryValue !== 'string') {
            return false;
        }
        return {
            selectedAmount: +rawQueryValue
        };
    },
    reset: (currentState) => {
    // NB: We do not want to save selectedAmount since the filter is reset
    //     (slider set to max)
        return {
            hasPrice: valueIn(currentState, 'hasPrice'),
            maximumPrice: valueIn(currentState, 'maximumPrice')
        };
    }
}));
